var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeezer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.820312,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#181818"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1013 12.5344H23.9492V14.9711H28.1013V12.5344Z",
    fill: "#40AB5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1013 15.9128H23.9492V18.3495H28.1013V15.9128Z",
    fill: "url(#paint0_linear_1149_17641)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1013 19.2912H23.9492V21.7279H28.1013V19.2912Z",
    fill: "url(#paint1_linear_1149_17641)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0515 22.6696H8.89941V25.1063H13.0515V22.6696Z",
    fill: "url(#paint2_linear_1149_17641)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0651 22.6696H13.9131V25.1063H18.0651V22.6696Z",
    fill: "url(#paint3_linear_1149_17641)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0876 22.6696H18.9355V25.1063H23.0876V22.6696Z",
    fill: "url(#paint4_linear_1149_17641)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1013 22.6696H23.9492V25.1063H28.1013V22.6696Z",
    fill: "url(#paint5_linear_1149_17641)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0876 19.2912H18.9355V21.7279H23.0876V19.2912Z",
    fill: "url(#paint6_linear_1149_17641)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0651 19.2912H13.9131V21.7279H18.0651V19.2912Z",
    fill: "url(#paint7_linear_1149_17641)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0651 15.9128H13.9131V18.3495H18.0651V15.9128Z",
    fill: "url(#paint8_linear_1149_17641)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1149_17641",
    x1: 26.0456,
    y1: 18.3705,
    x2: 26.0063,
    y2: 15.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#358C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5256,
    stopColor: "#33A65E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1149_17641",
    x1: 23.8882,
    y1: 21.6028,
    x2: 28.1696,
    y2: 19.4279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1149_17641",
    x1: 8.90017,
    y1: 23.8889,
    x2: 13.0488,
    y2: 23.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1149_17641",
    x1: 13.9177,
    y1: 23.8889,
    x2: 18.0663,
    y2: 23.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1149_17641",
    x1: 18.9344,
    y1: 23.8889,
    x2: 23.0829,
    y2: 23.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1149_17641",
    x1: 23.947,
    y1: 23.8889,
    x2: 28.0956,
    y2: 23.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3559A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1149_17641",
    x1: 18.7706,
    y1: 21.1665,
    x2: 23.2488,
    y2: 19.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1149_17641",
    x1: 13.77,
    y1: 19.6989,
    x2: 18.2171,
    y2: 21.3126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CE1938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1149_17641",
    x1: 14.2664,
    y1: 15.5341,
    x2: 17.7273,
    y2: 18.7179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5A22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezer);
export default __webpack_public_path__ + "static/media/deezer.db6d274c.svg";
export { ForwardRef as ReactComponent };